/**
 * @format
 */
const SolutionsIndexView = () => import('@/views/solutions/solutions-index-view.vue');

import store from '@/stores/index';

export default [
    // Agency Solutions Routes
    {
        path: '/Solutions',
        name: 'Solutions',
        component: SolutionsIndexView,
        meta: {
            type: 'agency',
            subtype: 'solutions',
            isUiShown: true,
            pageClass: 'agency-solutions-view',
            pageTitle: 'Solutions',
        },
    },
    {
        path: '/Agencies/:agencyId/Solutions',
        name: 'AgencySolutions',
        component: SolutionsIndexView,
        meta: {
            type: 'agency',
            subtype: 'solutions',
            isUiShown: true,
            pageClass: 'agency-solutions-view',
            pageTitle: 'Solutions',
        },
    },

    // Client Solutions Routes
    {
        path: '/Account/Customization/Solutions',
        name: 'AccountSolutions',
        component: SolutionsIndexView,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-solutions',
            pageTitle: 'Solutions',
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        },
    },
    {
        path: '/Clients/:clientId/Account/Customization/Solutions',
        name: 'ClientAccountSolutions',
        component: SolutionsIndexView,
        meta: {
            type: 'client',
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customizaton-solutions',
            pageTitle: 'Solutions',
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        },
    },
];
